import React, { useState, useRef } from "react";
import { Plus, Minus } from "lucide-react";

const PrintLayout = ({
  fontFamilyData,
  selectedFile,
  setSelectedFile,
  imageSize,
  setImageSize,
  award,
  setAward,
  selectedFont,
  setSelectedFont,
  activeStepTwo,
  textLogo,
  setTextLogo,
  simpleTextLogo,
  setSimpleTextLogo,
  clipartData,
  setSelectedClipart,
  selectedClipart,
  selectedClipartFile,
  setSelectedClipartFile,
  text,
  setText,
}) => {
  const fileInputRef = useRef(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
      setSelectedFile(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      alert("Please select a JPG or PNG file");
    }
  };

  const adjustImageSize = (increment) => {
    setImageSize((prev) => {
      const newSize = prev + (increment ? 10 : -10);
      return Math.min(Math.max(newSize, 10), 100);
    });
  };

  return (
    <>
      {/* {(activeStepTwo.id === "textAward" ||
        activeStepTwo.id === "textLogo" ||
        activeStepTwo.id === "textClipartAward" ||
        activeStepTwo.id === "textLogoAward") && ( */}
      <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
        <h2 className="text-lg font-medium text-gray-800 mb-4 bg-white/50 p-2 rounded-lg">
          TEXT
        </h2>
        <div className="relative">
          <input
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="Your Text Here"
            className="w-full p-3 text-gray-700 
            text-md
          bg-white 
          border border-purple-200 
          rounded-lg 
          appearance-none 
          focus:outline-none 
          focus:ring-2 
          focus:ring-purple-300 
          focus:border-transparent 
          transition-all 
          duration-300"
          />
        </div>
      </div>
      {/* )} */}

      {/* {activeStepTwo.id === "text" && ( */}
      {/* <div className="p-6 max-w-2xl p-8 max-w-4xl m-4 border border-gray bg-[#dedede] shadow-sm">
          <div className="">
            <h2 className="text-lg font-medium text-gray-700 mb-4">TEXT</h2>
            <input
              type="text"
              value={text}
              onChange={(e) =>
                setText( e.target.value )
              }
              placeholder="Your Text Here"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-purple-500"
            />
          </div>
        </div> */}
      {/* )} */}
      {/* {(activeStepTwo.id === "logoAward" ||
        activeStepTwo.id === "logo" ||
        activeStepTwo.id === "textLogo" ||
        activeStepTwo.id === "textLogoAward") && ( */}
      <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
        <h2 className="text-lg font-medium text-gray-800 mb-4 bg-white/50 p-2 rounded-lg">
          ADD YOUR LOGO/CUSTOM IMAGE
        </h2>

        <p className="text-gray-600 mb-4 bg-white/50 p-2 rounded-lg">
          Upload a JPG or PNG file
        </p>

        <div className="flex items-center gap-4 mb-4">
          <button
            onClick={(e) => {
              e.preventDefault();
              fileInputRef.current?.click();
            }}
            className="px-4 py-2 
            bg-white 
            border border-purple-200 
            text-gray-700 
            rounded-lg 
            hover:bg-purple-50
            focus:outline-none 
            focus:ring-2 
            focus:ring-purple-300 
            focus:border-transparent 
            transition-all 
            duration-300"
          >
            {selectedFile?.name ? "CHANGE FILE" : "CHOOSE FILE"}
          </button>
          <span className="text-gray-600 bg-white/50 px-3 py-2 rounded-lg">
            {selectedFile ? selectedFile.name : "No File Chosen"}
          </span>
          <input
            ref={fileInputRef}
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) => handleFileChange(e)}
            className="hidden"
          />
        </div>

        {imagePreview && (
          <div className="bg-white/50 p-2 rounded-lg">
            <img
              src={imagePreview}
              alt="Uploaded Preview"
              style={{ width: `${imageSize}%`, height: "auto" }}
              className="rounded-lg border border-purple-200"
            />
          </div>
        )}
      </div>

      {/* <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
        <h2 className="text-lg font-medium text-gray-800 mb-4 bg-white/50 p-2 rounded-lg">
          AWARD
        </h2>
        <div className="relative">
          <input
            type="text"
            value={award.text}
            onChange={(e) => setAward({ ...award, text: e.target.value })}
            placeholder="1st, 2nd, 3rd etc."
            className="w-full p-3 
          text-gray-700 
          bg-white 
          border border-purple-200 
          rounded-lg 
          appearance-none 
          focus:outline-none 
          focus:ring-2 
          focus:ring-purple-300 
          focus:border-transparent 
          transition-all 
          duration-300"
          />
        </div>
      </div>

      <div className="p-6 max-w-4xl m-4 border border-gray bg-gradient-to-r from-purple-50 to-blue-50 rounded-lg shadow-md">
        <h2 className="text-lg font-medium text-gray-800 mb-4 bg-white/50 p-2 rounded-lg">
          FONT
        </h2>
        <div className="space-y-2 max-h-48 overflow-y-auto pr-2 custom-scrollbar">
          {fontFamilyData.map((font) => (
            <button
              key={font}
              onClick={(e) => {
                e.preventDefault();
                setSelectedFont(font.fontKey);
              }}
              className={`w-full p-3 text-left rounded-lg transition-all duration-300
             ${
               selectedFont === font.fontKey
                 ? "bg-purple-600 text-white shadow-md hover:bg-purple-700"
                 : "bg-white hover:bg-purple-50 border border-purple-200"
             }`}
              style={{ fontFamily: font.fontKey }}
            >
              {font.name}
            </button>
          ))}
        </div>
      </div> */}
      {/* )} */}
      {/* {(activeStepTwo.id === "logoAward" ||
        activeStepTwo.id === "textAward" ||
        activeStepTwo.id === "textClipartAward" ||
        activeStepTwo.id === "textLogoAward") && (
        
      )}
      {activeStepTwo.id !== "logo" && (
        <div className="p-6 max-w-2xl p-8 max-w-4xl m-4 border border-gray bg-[#dedede] shadow-sm">
          <div className="">
            <h2 className="text-lg font-medium text-gray-700 mb-4">FONT</h2>
            <div className="space-y-2 max-h-48 overflow-y-auto">
              {fontFamilyData.map((font) => (
                <button
                  key={font}
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedFont(font.fontKey);
                  }}
                  className={`w-full p-3 text-left rounded transition-colors
                ${
                  selectedFont === font.fontKey
                    ? "bg-purple-600 text-white"
                    : "bg-white hover:bg-gray-100"
                }`}
                  style={{ fontFamily: font.fontKey }}
                >
                  {font.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {activeStepTwo.id === "textClipartAward" && (
        <div className="p-6 max-w-2xl py-8 ps-8 max-w-4xl m-4 border border-gray bg-[#dedede] shadow-sm">
          <h2 className="text-lg font-medium text-gray-700 mb-4">
            Images{" "}
            <sup className="text-xs">
              - click to add (You may need to resize your text)
            </sup>
          </h2>

          <div className="relative">
            <select
              value={selectedClipart}
              onChange={(e) => setSelectedClipart(e.target.value)}
              className="w-full p-3 text-gray-700 bg-white border border-gray-300 rounded-md appearance-none cursor-pointer focus:outline-none focus:border-blue-500"
            >
              {clipartData.map((option) => (
                <option key={option.name} value={option.name} className="py-2">
                  {option.name}
                </option>
              ))}
            </select>

            <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
              <svg
                className="w-5 h-5 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </div>
          </div>
          <div className={`h-48 mt-4`}>
            {clipartData.map(
              (clipart, index) =>
                clipart.name === selectedClipart && (
                  <div
                    key={index}
                    className="grid grid-cols-4 gap-3 h-48 overflow-x-auto"
                  >
                    {clipart.images.map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        onClick={(e) => {
                          setSelectedClipartFile(image);
                        }}
                        className={`flex flex-col items-center p-2`}
                      >
                        <div
                          className="relative w-14 h-14 rounded-md overflow-hidden group cursor-pointer"
                          style={{
                            backgroundImage: `url(${image.image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        ></div>
                      </div>
                    ))}
                  </div>
                )
            )}
          </div>
          <style jsx>{`
            select option:checked {
              background: #2563eb;
              color: white;
            }

            select option:hover {
              background: #3b82f6;
            }
          `}</style>
        </div>
      )} */}
    </>
  );
};

export default PrintLayout;
